import { Box, Text } from '@chakra-ui/react';

/**
 * Re-usable inline segments that match the visual treatment used by the
 * real recognition feed. The Bizy draft cards have TYPED fields (giver,
 * recipient, amount, message, hashtags) and never see the composed text,
 * so we render the same visual primitives directly.
 *
 * Styling references the host theme's semantic tokens:
 *   - Amount:    `points.fg` on `points.bgAlpha` pill, font-weight medium
 *   - Recipient: `primary.fg`,                          font-weight medium
 *   - Hashtag:   `hashtag.fg`
 */

export function AmountPill({ amount }: { amount: number }) {
	return (
		<Box as="span" display="inline-flex" bgColor="points.bgAlpha" borderRadius="full" alignItems="center" px={2} py={0} verticalAlign="baseline">
			<Text as="span" fontSize="inherit" color="points.fg" fontWeight="medium">
				+{amount}
			</Text>
		</Box>
	);
}

export function RecipientHandle({ username }: { username: string }) {
	const handle = username.startsWith('@') ? username : `@${username}`;
	return (
		<Text as="span" fontSize="inherit" color="primary.fg" fontWeight="medium">
			{handle}
		</Text>
	);
}

export function HashtagToken({ hashtag }: { hashtag: string }) {
	const tag = hashtag.startsWith('#') ? hashtag : `#${hashtag}`;
	return (
		<Text as="span" fontSize="inherit" color="hashtag.fg" fontWeight="medium">
			{tag}
		</Text>
	);
}
